/**
 * Color theme switcher
 */
(() => {
    let doc = document.documentElement;
    let simulacra = document.querySelectorAll('.js-color-theme-simulacrum');
    let selectors = document.querySelectorAll('.js-theme-selector');
    let toggles = document.querySelectorAll('.js-theme-toggle');

    if (!selectors.length && !toggles.length) {
        return;
    }

    // Load the last selected color theme from local storage
    const initialColorTheme = localStorage.getItem('colorTheme');

    if (!initialColorTheme) {
        console.error('Color theme not found in local storage!');
        return;
    }

    const toggle_themes = ['light', 'dark']; // Must have two elements
    const select_themes = ['light', 'dark', 'os-default'];

    function activate_theme(theme) {
        clear_classes(select_themes);
        doc.classList.add('-theme-' + theme);
        simulacra.forEach((simulacrum) => {
            simulacrum.classList.add('-theme-' + theme);
        });

        // Update local storage
        localStorage.setItem('colorTheme', theme);
    }

    function clear_classes(themes) {
        themes.forEach((theme) => {
            doc.classList.remove('-theme-' + theme);
            simulacra.forEach((simulacrum) => {
                simulacrum.classList.remove('-theme-' + theme);
            });
        });
    }

    function update_toggle_modifier(toggle, theme) {
        toggle.classList.toggle(
            '-' + toggle_themes[0],
            theme === toggle_themes[0]
        );
        toggle.classList.toggle(
            '-' + toggle_themes[1],
            theme === toggle_themes[1]
        );
    }

    selectors.forEach((selector) => {
        selector.value = initialColorTheme;
    });

    toggles.forEach((toggle) => {
        update_toggle_modifier(toggle, initialColorTheme);
    });

    // Listen for changes to the color theme select element and update the page accordingly
    selectors.forEach((selector) => {
        selector.addEventListener('change', function () {
            activate_theme(this.value);
        });
    });

    // Listen for changes to the color theme select element and update the page accordingly
    toggles.forEach((toggle) => {
        toggle.addEventListener('click', function () {
            const selectedTheme = this.classList.contains(
                '-' + toggle_themes[0]
            )
                ? toggle_themes[1]
                : toggle_themes[0];

            activate_theme(selectedTheme);

            // Set toggle modifier class
            update_toggle_modifier(this, selectedTheme);
        });
    });
})();
